require('../../basic.css');
require('./pagelist.scss');
let util = require('../util');

let mobileUtil = require('f.core.mobile.util');

let Events = require('f.core.event');

let DataCenter = require('f.component.datacenter.mobile');

let newsItem = require('./newsItem.ejs');
let Audio = require('f.component.audio.mobile');
let Pic = require('f.component.pic.mobile');
let Video = require('f.compenont.video.mobile').listVideo;
let Skeleton = require('./skeleton.ejs');

let topMid = null;
// 时间分割线
let lastItemDate = null; // 最后一个比对的时间

let getVideoInfo = function(options) {
    if (options.from && options.from === 'ugc') {
        // console.log('getVideoInfo:ugc');
        // 请求ugc 的视频接口 // ugc 赵璐/于老师
        let msg = options.ugcuid + '@' + options.video_id;
        return $.ajax({
            url: '//api.cmpp.v.ifeng.com/index.php/live/video',
            dataType: 'jsonp',
            data: {
                msg: msg,
                rt: 'js',
                param: 'playermsg'
            }
        });
    } else {
        // console.log('getVideoInfo:mengshuai');
        // 姣艳/孟帅
        let id = options.video_id.split('-')[0]; // 防止间隔号-导致请求报错
        return $.ajax({
            url: '//tv.ifeng.com/h6/' + id + '__callback' + id + '_/video.json',
            type: 'get',
            jsonpCallback: 'callback' + id,
            dataType: 'jsonp'
        });
    }
};
let antiTheftChain = function(data) {
    let settings = data; // Object.assign(gloableSettings, data);
    let _obj = {
        videoinfo: settings,
        __gid: window.createGid(),
        version: 'izhiboHTML5Player_v1.0.0',
        from: 'izhibo_h5'
    };
    // 生成防盗链
    let antiTheftUrl = antiTheft(_obj);
    return antiTheftUrl;
};

let LivePage = function(options, native) {
    console.log('livepage=======>', options);
    this.native = native;
    this.orignalScrollTop = 0;
    this.touchStartY = 0;
    this.touchEndY = 0;
    this.shrinkTimer = null;
    this.init(options);
};

LivePage.prototype.init = function(options) {
    this.options = options;
    this.dataCenter = new DataCenter(options);
    this.resolveTemplate();
    this.bindDomEvent();
    this.bindDataEvent();
};

LivePage.prototype.stop = function() {
    this.dataCenter.stop();
};

LivePage.prototype.pause = function() {
    this.isnotice = true;
};

LivePage.prototype.play = function() {
    this.isnotice = false;
};

LivePage.prototype.start = function() {
    this.dataCenter.start();
};

LivePage.prototype.bindDataEvent = function() {
    // 初始化渲染
    let _self = this;

    // 置顶消息，推送消息
    this.dataCenter.on('top', function(item, hasUpdate) {
        console.log(hasUpdate);
        if (_self.isnotice && hasUpdate) {
            _self.trigger('newMessage');
        }

        _self.renderTop($('.js_timelineTop'), item);
    });

    // 当数据的发生变化时监控，items push的数据，绘制数据
    this.dataCenter.on('tail', function(items, hasUpdate) {
        if (_self.isnotice && hasUpdate) {
            console.log('hasUpdate:' + hasUpdate);
            _self.trigger('newMessage');
        }
        _self.renderItems($('.js_timelineContainer'), items, false);
    });

    // 当数据的发生变化时监控，items push的数据，绘制数据
    this.dataCenter.on('head', function(items, hasUpdate) {
        if (_self.isnotice && hasUpdate) {
            console.log('hasUpdate:' + hasUpdate);
            _self.trigger('newMessage');
        }
        _self.renderItems($('.js_timelineContainer'), items, true);
    });

    // 清空数据
    this.dataCenter.on('clear', function() {
        _self.clearItem($('.js_timelineContainer'));
    });

    mobileUtil.tap(this.container[0], function(e) {
        if (e.target.classList.contains('detail_url')) {
            let link = e.target.dataset.link.replace(/^\s+|\s+$/g, '');
            if (_self.native.isApp) {
                _self.native.openWeb(link, true);
            } else {
                window.open(link);
            }
        }
    });
};

LivePage.prototype.resolveTemplate = function() {
    let pageHtml = Skeleton();
    this.container = $(pageHtml);
    this.ownerNode = this.container;
};

// //绑定元素中的代理事件
LivePage.prototype.bindDomEvent = function() {
    let _self = this;

    $(this.container)
        .find('.mod-loading')
        .hide();
    // 显示更多
    let isLoading = false;
    let self = this;

    this.container[0].addEventListener('touchstart', function() {
        if (this.scrollTop === 0) {
            this.scrollTop = 1; // 防止拖动全页面
        }
    });

    const handleScrollDirect = function(direction, listScrollTop) {
        _self.trigger('shrink', { direct: direction, topDistance: listScrollTop });
    };

    this.container[0].addEventListener('scroll', function() {
        let scrollTop = this.scrollTop;
        if (isLoading) {
            return;
        }
        let elItems = $(this).find('.mod-newsList-box')[0];
        let wrapH = elItems.offsetHeight;
        let winH = this.offsetHeight;
        if (wrapH - scrollTop <= winH + 10) {
            isLoading = true;
            console.log('isLoading : ' + isLoading);
            $(this)
                .find('.mod-loading')
                .show();
            _self.dataCenter.requestMore(function() {
                $(self)
                    .find('.mod-loading')
                    .hide();
                isLoading = false;
            });
        }
    });

    this.container[0].addEventListener('touchstart', function(e) {
        _self.touchStartY = e.touches[0].pageY;
    });

    this.container[0].addEventListener('touchmove', function(e) {
        const _thisContainer = this;
        _self.shrinkTimer = setTimeout(function() {
            _self.touchEndY = e.changedTouches[0].pageY;
            const delta = _self.touchEndY - _self.touchStartY;
            if (delta < 0) {
                handleScrollDirect('down', _thisContainer.scrollTop);
            } else {
                handleScrollDirect('up', _thisContainer.scrollTop);
            }
        }, 100);
    });
};

// ============================ 页面渲染方法
/**
 * 重画置顶
 * @param itemData 置顶数据
 * @param isTop 是否置顶
 */
LivePage.prototype.renderTop = function(container, itemData) {
    let curDate = new Date();
    let year = curDate.getFullYear();
    let month = curDate.getMonth() + 1;
    let date = curDate.getDate();
    let curDateStr = year + '-' + ((month + '').length == 1 ? '0' + month : month) + '-' + ((date + '').length == 1 ? '0' + date : date);
    let dateStr = util.getDate(itemData.ctime);
    topMid = itemData.mid;
    itemData.isTop = true;
    itemData.isAd = false;
    itemData.abstract1 = itemData.abstract;
    // 头条添加推广位
    if (itemData.important && itemData.isTop) {
        itemData.covertime = '推广';
        itemData.isAd = true;
    } else {
        itemData.covertime = util.timeHandle(itemData.ctime);
    }

    itemData.daytime = util.timeHandleDay(itemData.ctime);
    itemData.hasRelyContent = itemData.quote_message.length > 0;
    itemData.hasContent = typeof itemData.abstract !== 'undefined' && itemData.abstract != '';
    itemData.uid = itemData.ugcuid;
    itemData.converVedioImage = this.replaceImgServer(itemData.video_image);
    if ((typeof lastItemDate === 'undefined' || dateStr != lastItemDate) && dateStr != curDateStr) {
        console.log(lastItemDate);
        console.log(dateStr);
        itemData.dateStr = dateStr;
        lastItemDate = dateStr;
    }
    let html = newsItem({ items: [itemData] });
    container.empty();
    container.append(html);
    let contentNode = container.find('.news-con')[0];
    this.renderComponents(contentNode, itemData);
};

/**
 * 清空列表
 */
LivePage.prototype.clearItem = function(container) {
    container.empty();
    $('.mod-showMoreBtn').show();
};

/**
 * 绘制更新的内容
 * @param {Object}container 需要绘制的容器
 * @param {Array}items 需要绘制的数据
 * @param {boolean}ishead  是否是头部添加
 */
LivePage.prototype.renderItems = function(container, items, ishead) {
    let contentNode;
    let curlength = container.find('.news-con').length;

    let curDate = new Date();
    let year = curDate.getFullYear();
    let month = curDate.getMonth() + 1;
    let date = curDate.getDate();
    let curDateStr = year + '-' + ((month + '').length == 1 ? '0' + month : month) + '-' + ((date + '').length == 1 ? '0' + date : date);
    let temp = [];
    for (let i = 0; i < items.length; i++) {
        let dateStr = util.getDate(items[i].ctime);
        // 排除头条
        if (items[i].mid === topMid) {
            continue;
        }
        // 显示头条
        // if(items[i].mid === topMid) {
        //     items[i].dateStr = null;
        // }
        items[i].isTop = false;
        items[i].abstract1 = items[i].abstract;
        items[i].covertime = util.timeHandle(items[i].ctime);
        items[i].daytime = util.timeHandleDay(items[i].ctime);
        items[i].hasRelyContent = items[i].quote_message.length > 0;
        items[i].hasContent = typeof items[i].abstract !== 'undefined' && items[i].abstract != '';
        items[i].uid = items[i].ugcuid;

        if (items[i].hasRelyContent) {
            items[i].quote_message[0].converImage = this.replaceImgServer(items[i].quote_message[0].image);
            items[i].quote_message[0].coverCtime = util.timeHandleNosecond(items[i].quote_message[0].ctime);
        }
        items[i].converVedioImage = this.replaceImgServer(items[i].video_image);
        if (ishead) {
            items[i].isTop = false;
            items[i].ishead = true;
        }

        if ((typeof lastItemDate === 'undefined' || dateStr != lastItemDate) && dateStr != curDateStr) {
            items[i].dateStr = dateStr;
            lastItemDate = dateStr;
        }
        let ItemDom = $(newsItem({ items: [items[i]] }));
        contentNode = ItemDom.find('.news-con')[0];

        this.renderComponents(contentNode, items[i]);

        if (ishead) {
            container
                .children()
                .first()
                .before(ItemDom);
        } else {
            container.append(ItemDom);
        }
    }
};

LivePage.prototype.renderComponents = function(contentNode, item) {
    let picHtml, picData, audioData, audioHtml, videoData, videoHtml;
    if (item.pictures && item.pictures.length > 0) {
        picData = {
            pictures: item.pictures,
            mid: item.mid
        };
        new Pic(contentNode, picData);
        // picHtml.renderTo(contentNode);
    }
    if (item.audio_url) {
        audioData = {
            audio_url: item.audio_url,
            audio_id: item.audio_id,
            audio_duration: item.audio_duration
        };
        audioHtml = new Audio(audioData);
        audioHtml.renderTo(contentNode);
    }

    if (item.video_id) {
        let id = item.video_id;
        Promise.resolve()
            .then(() => getVideoInfo(item))
            .then((data) => {
                // console.log('promise==', data);
                let videoUrl = item.video_url;
                if (data) {
                    // 不是金山
                    data.vid = id;
                    videoUrl += antiTheftChain(data) ? '?' + antiTheftChain(data) : '';
                }
                // console.log('videoUrl===', videoUrl);
                videoData = {
                    from: 'pomp',
                    uid: item.uid,
                    mid: item.mid,
                    video_url: videoUrl,
                    video_image: item.video_image,
                    isTop: item.isTop,
                    swfUrl: '//vxml.ifengimg.com/swf/zuhe/zuhePlayer_v1.0.47.swf',
                    AutoPlay: true
                };
                videoHtml = new Video(videoData);
                console.log(videoHtml);
                videoHtml.renderTo(contentNode);
            });
    }
};

LivePage.prototype.replaceImgServer = function(imageAddr) {
    if (imageAddr === '') return '';
    return this.options.imageServer + '/' + this.options.imageRatio + '/' + imageAddr.replace(/http[s]?:\/\//, '');
};

LivePage.prototype.renderTo = function(parentNode) {
    this.parentNode = parentNode;
    parentNode.appendChild(this.container[0]);
};

Events.mixTo(LivePage);

module.exports = LivePage;



// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.component.pagelist.mobile/app/modules/view/index.js